<div class="relative">
    <div class="bg-white px-5 py-4 shadow-(--shadow-input) rounded-2xl mb-2 transition relative {{customClass}}"
        [ngClass]="{
    'focus-within:ring-1 focus-within:ring-blue-500': !hasErrorState,
    'ring-1 ring-(--color-error)': hasErrorState  && !showInlineError
  }">
        <label class="block font-medium text-base" [attr.for]="inputId">
            {{ label | translate }}
        </label>
        <div class="flex gap-2 items-center" dir="ltr">
            <input #input (input)="onInputChange($event.target.value)" [value]="displayValue" [id]="inputId"
                [placeholder]="placeholder" type="text"
                class="input-field w-full placeholder:text-(--text-placeholder) order-2 rtl:order-1 rtl:text-end" />
        </div>

        <button class="absolute top-1/2 -translate-y-1/2 ltr:right-4 rtl:left-4 cursor-pointer hover:opacity-80"
            (click)="onCalendarClick()" type="button">

            <img [src]="defaultSelection === 'month' || defaultSelection === 'year' ? 'assets/icons/arrow-down-sm.svg' : 'assets/icons/calendar.svg'"
                alt="icon" class="lg:w-5 lg:h-5 w-3 h-3" />
        </button>

    </div>
    <p class="text-(--text-secondary) text-sm leading-5" *ngIf="!showInlineError">e.g., 12/Jan/1994 or 12/01/1994</p>
    <!-- Error Message -->
    <p *ngIf="hasErrorState && !showInlineError" class="text-(--color-error) text-sm mt-0 font-medium mb-4">
        {{ errorMessage | translate}}
    </p>
</div>